/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "../../components/Loadable";

const Applications = Loadable(lazy(() => import("sections/applications/index")));

const applicationRoutes = [
    {
        path: "applications",
        element: <Applications />,
    },
];

export { applicationRoutes };
